<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'用户认证审核',goback:true},{name:'用户认证审核详情'}]" :title="'用户认证审核详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="账号信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">账号：</div>
                        <div class="content">{{detail.userName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">账号类型：</div>
                        <div class="content">{{detail.userTypeName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">姓名：</div>
                        <div class="content">{{detail.realName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">邮箱：</div>
                        <div class="content">{{detail.email}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">联系地址：</div>
                        <div class="content">{{detail.contactAddress}}</div>
                    </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="认证信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">企业全称：</div>
                        <div class="content">{{detail.companyName}}</div>
                    </div>  
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">统一社会信用代码：</div>
                        <div class="content">{{detail.companyNum}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">用户类型：</div>
                        <div class="content">{{detail.userTypeName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">联系人：</div>
                        <div class="content">{{detail.contact}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">联系手机号：</div>
                        <div class="content">{{detail.contactPhone}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8" v-show="detail.userType=='BANK' || detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'">
                   <div class="child">
                            <div class="name">LOGO：</div>
                            <div class="content"><img class="logos" :src="detail.frontPath+detail.logoUrl"></div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-show="detail.userType=='BANK'">
                    <div class="child">
                            <div class="name">银行名称：</div>
                            <div class="content">{{detail.abbreviation}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-show="detail.userType=='BANK'">
                    <div class="child">
                            <div class="name">官网链接：</div>
                            <div class="content">{{detail.websiteLink}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8"  v-show="detail.userType=='BANK' || detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'">
                    <div class="child">
                            <div class="name">{{detail.userType=='BANK'?'简介':'公司简介'}}：</div>
                            <div class="content">{{detail.remarks}}</div>
                        </div>
                  </el-col>
                  
                  <el-col :span="8" v-show="detail.userType=='FINANCE_LEASING_COMPANY'">
                    <div class="child">
                            <div class="name">分类：</div>
                            <div class="content">{{detail.classifyName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{detail.createTime}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-show="detail.userType=='INSTITUTIONAL_INVESTOR' || detail.userType=='CORPORATE_CLIENTS' || detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'">
                    <div class="child">
                            <div class="name">{{detail.userType=='INSTITUTIONAL_INVESTOR'?'名片':'营业执照'}}：</div>
                            <div class="content"><img class="license"
                                                      :src="detail.frontPath+detail.attachmentUrl"></div>
                        </div>
                  </el-col>
                </el-row>
                <!-- <el-row v-if="tab==='2'">
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{detail.checkStatusName}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detail.auditAccount}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detail.updateTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detail.auditInstructions}}</div>
                        </div>
                    </el-col>
                  </el-row> -->
              </el-card>
              <el-card class="basic box_card mt16" header="审核结果" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{detail.checkStatusName}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detail.auditAccount}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detail.updateTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detail.auditInstructions}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detail:{},//数据
			debtStatistics:'',//债权融资统计
			financialLeasingStatistics:'',//融资租赁统计
			equityStatistics:'',//股权融资列表统计
			vouchStatistics:'',//担保服务统计
			policyGuidanceStatistics:'',//政策指引统计
			incubatorStatistics:'',//孵化器统计
			activitySalonStatistics:'',//活动沙龙统计
        }
    },
    methods:{
        
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosz.get('backstage/sysUserReviewLog/' + this.id)
          if (code == 200) {
              this.detail = data;
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
    // margin-top: 20px;
    height:calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>